import React, { Component, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/AddBox";
import ManageTemplate from "./manage_crf";
import DataService from "../../../../Service";
import { makeStyles } from "@material-ui/core";
import Loader from "../../../../Components/Loader";
import { createStyles, withStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import HeaderMenu from "../../../../Components/HeaderMenu";
import useDebounce from "../../../../Components/debounce";
import RightDrawer from "../../../../Components/RightDrawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";
import ManageCompleteCRF from "./manage_complete_crf";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { ReactComponent as CRFIcon1 } from "../../../../Images/CRFIcon1.svg";
import { ReactComponent as CRFIcon2 } from "../../../../Images/CRFIcon2.svg";
import { ReactComponent as CRFIcon3 } from "../../../../Images/CRFIcon3.svg";
import { ReactComponent as CRFIcon4 } from "../../../../Images/CRFIcon4.svg";
import Popper from "@material-ui/core/Popper";
import InputBase from "@material-ui/core/InputBase";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import FilterList from "@material-ui/icons/FilterList";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { showSnackbar } from "../../../../Components/Snackbar/SnackbarActions";
import { useDispatch, useSelector } from "react-redux";
import User from "../../../../Images/User.png";
import { TooltipWrapper } from "../../../../Common/Utils/common_utils";
import CompleteCrf from "./ManageCompleteCrf";
const useStyles1 = makeStyles((Theme) =>
  createStyles({
    root: {
      position: "relative",
      "& .MuiOutlinedInput-root": {
        padding: "3px",
      },
      "& .MuiTextField-root": {
        "& p": {
          marginLeft: "0px",
          marginTop: "4px",
        },
      },
      "& .MuiInputBase-input": {
        fontSize: 16,
        padding: "3.5px 5px",
        "&::placeholder": {
          color: "#808080",
          opacity: 1,
        },
      },
      "& .MuiOutlinedInput-multiline": {
        padding: 0,
      },
    },
  })
);

const useStyles = makeStyles((theme) => ({
  wrapper: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: theme.spacing(1, 2),
    border: "1px solid #d5d5d5",
    marginLeft: "41px",
    marginBottom: "20px",
    marginTop: "10px",
    paddingLeft: "2px",
    paddingTop: "3px",
    paddingBottom: "8px",
    width: "28%",
    height: "40px",
  },
  wrapperFilter: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "4%",
    width: "94%",
  },
  statsBoard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    width: "16%",
    height: "47px",

    // borderColor:'#56D9FE'
  },
  IconBorderAll: {
    width: "42px",
    height: "40px",
    paddingTop: "8px",
    textAlign: "center",
    borderRadius: "5px",
    marginLeft: "100px",
    backgroundColor: "#320032",
  },
  IconBorder1: {
    width: "42px",
    height: "40px",
    paddingTop: "8px",
    textAlign: "center",
    borderRadius: "5px",
    marginLeft: "92px",
    backgroundColor: "#320032",
  },
  activeTab: {
    borderLeft: "solid #077F83",
  },
  IconBorder: {
    width: "42px",
    height: "40px",
    paddingTop: "8px",
    textAlign: "center",
    borderRadius: "5px",
    marginLeft: "60px",
    backgroundColor: "#320032",
  },
  IconBorderReq: {
    width: "42px",
    height: "40px",
    paddingTop: "8px",
    textAlign: "center",
    borderRadius: "5px",
    marginLeft: "62px",
    backgroundColor: "#320032",
  },
  IconBorder2: {
    width: "42px",
    height: "40px",
    paddingTop: "8px",
    textAlign: "center",
    borderRadius: "5px",
    marginLeft: "38px",
    backgroundColor: "#320032",
  },
  formWrapper: {
    background: "#fff",
    width: "400px",
    // padding: theme.spacing(3),
  },

  actionButtons: {
    paddingTop: "35px",
    textAlign: "right",
    // "& button": {
    //   marginRight: "40px",
    // },
  },
  tableWrapper: {
    width: "95%",
    paddingLeft: "2%",
    margin: "1% 3%",
  },
  title: {
    textTransform: "none",
    fontWeight: "bold",
    width: "85%",
  },
  bodyContainer: {
    // maxWidth: "95%",
    // flexGrow: 1,
    margin: "0 auto",
    marginTop: "20px",
  },
  bodyContainer1: {
    // maxWidth: "95%",
    margin: "0 auto",
    marginTop: "20px",
  },
  row: {
    "& button": {
      display: "none",
    },
    "&:hover": {
      "& button": {
        display: "inline-block",
      },
    },
  },
}));
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const rawData = [];
export default function SimpleAction() {
  const classes = useStyles();
  const classes1 = useStyles1();
  const globaluserData = useSelector((state) => state.commonReducer);

  const [currentSelection, setCurrentSelection] = useState({});
  const [completeAction, setCompleteAction] = useState(false);
  const [action, setAction] = useState("");
  const [filterAction, setFilterAction] = useState(false);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [filterValue, setFilterValue] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  // const debouncedSearchText = useDebounce(searchText, 700);
  const [apiData, setApiData] = useState([]);
  let role = globaluserData?.role;
  let organisationId = globaluserData?.organisation_id;
  // const [open, setOpen] = [false];
  const [organisationName, setOrgnaisationName] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchTextSelect, handleSearchText] = useState(null);
  const debouncedSearchText = useDebounce(searchTextSelect, 700);
  const anchorRef = React.useRef(null);

  const [data, setData] = useState(rawData);
  const [open, setOpen] = React.useState(false);
  const [feildValue, setFeildValue] = useState([]);
  const [value, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");
  const [empValue, setEmpValue] = React.useState("");
  const [empInputValue, setEmpInputValue] = React.useState("");
  const [selectData, setSelectData] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [userData, setUserData] = useState({});
  const dispatch = useDispatch();
  const getEmployeeData = () => {
    const params = {
      organisation_id:
        value !== null || value !== ""
          ? value.id
          : setCurrentSelection?.organisation_id,
    };
    DataService.getDirectData(`/coaching_request_forms/employee_list`, params)
      .then((response) => {
        let listData = response["employees"];
        setEmpData(listData);
        setLoading(false);
      })

      .catch((err) => {});
  };
  const getDropData = () => {
    setLoading(true);

    DataService.getDirectData(`/organisations`)
      .then((response) => {
        let listData = response["organisations"];
        setSelectData(listData);
        setLoading(false);
      })
      .catch((err) => {});
    if (inputValue !== "") {
      getEmployeeData();
    }
  };

  useEffect(() => {
    if (role === "employee") {
      setLoading(true);
      getEmployeeData();
    }
  }, []);
  useEffect(() => {
    setLoading(true);
    getDropData();
  }, [value]);
  useEffect(() => {
    setFeildValue(data.module_form_fields);
  }, [feildValue, value]);

  const getData = () => {
    // setLoading(true);
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 100,
      approval_status: filterValue || null,
      search: debouncedSearchText || null,
      organisation_name: inputValue || null,
      coachee_name: empInputValue || null,
      // organisation_id:id
    };
    DataService.getDirectData(`/crf_users`, params)
      .then((response) => {
        if (response.crf_users) {
          let listData = response["crf_users"];
          setApiData(listData);
          setCurrentSelection(listData[0]);
          setData(response);
          setTotalCount(response.total_count);
          // handleCloseDialog()
        }

        setLoading(false);
      })
      .catch((error) => {
        dispatch(showSnackbar("error", [["" + error.errors]]));
      });
  };

  const getSpecificData = () => {
    setLoading(true);
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 5,
      approval_status: filterValue || null,
      search: debouncedSearchText || null,
      organisation_id: organisationId,
    };
    DataService.getDirectData(`/crf_users`, params)
      .then((response) => {
        if (response.crf_users) {
          let listData = response["crf_users"];
          setApiData(listData);
          setCurrentSelection(listData[0]);
          setData(response);
          setTotalCount(response.total_count);
        } else {
          setData([]);
          setApiData([]);
        }
        setLoading(false);
      })

      .catch((err) => {});
  };

  useEffect(() => {
    setLoading(true);
    if (role === "partner" || role === "employee") {
      getSpecificData();
      setIsAdmin(true);
    } else {
      getData();
      setIsAdmin(false);
    }
  }, [filterValue, page, pageSize, debouncedSearchText]);

  const handleClear = () => {
    setEmpInputValue("");
    setInputValue("");
    setValue("");
    setEmpValue("");
    handleSearchText("");
  };

  let history = useHistory();
  const movePreviousPage = () => {
    history.goBack();
  };
  const statusMapButtons = {
    Approved: "button-positive",
    "Pending review by acuity": "button-warning",
    Declined: "button-negative",
  };
  const columns = [
    {
      title: "Coachee name",
      headerStyle: { paddingLeft: "37px" },
      customSort: (a, b) =>
        a.coachee_name &&
        b.coachee_name &&
        a.coachee_name.localeCompare(b.coachee_name),
      cellStyle: {
        width: "auto",
      },
      field: "imageUrl",
      render: (rowData) => (
        <div
          className="center"
          style={{ paddingLeft: "16px", display: "flex", gap: "1rem" }}
        >
          <img
            src={rowData.image || User}
            alt=" "
            style={{ width: "30px", borderRadius: "50%", height: "30px" }}
          />
          <span style={{ textAlign: "left" }}>
            {rowData?.coachee_name || ""}
          </span>
        </div>
      ),
    },
    {
      title: "Organization",
      field: "organisation",
      customSort: (a, b) =>
        a.organisation &&
        b.organisation &&
        a.organisation.localeCompare(b.organisation),
      hidden: !isAdmin ? false : true,
    },
    {
      title: `Submitter's job title`,
      field: "job_title",
      customSort: (a, b) =>
        a.job_title && b.job_title && a.job_title.localeCompare(b.job_title),
    },
    {
      title: "Submission date",
      field: "submitted_at",
      sorting: false,
      hidden: role === "employee" ? true : false,
    },
    {
      title: "Submitted date",
      field: "submitted_date",
      sorting: false,
      hidden: isAdmin === true ? false : true,
    },
    { title: "Submitted by", field: "submitted_by", sorting: false },
    // {
    //   title: "Office country",
    //   field: "office_country",

    //   headerStyle: {
    //     width: "17%",
    //   },
    //   cellStyle: {
    //     width: "17%",
    //   },
    // },
    {
      title: "Approval status",
      sorting: false,
      field: "status",
      render: (rowData) => (
        <div
          className={statusMapButtons[rowData.approval_Status]}
          variant="outlined"
        >
          <b>{rowData.approval_Status}</b>
        </div>
      ),
    },
    {
      title: "",
      sorting: false,
      field: "username_password",
      render: (rowData) => (
        <Button
          variant="contained"
          style={{
            padding: "6px",
            fontSize: "13px",
            textTransform: "initial",
            backgroundColor: "#320032",
          }}
          onClick={(event) => {
            setCurrentSelection(rowData);
            setAnchorEl(event.currentTarget);
            setAction("edit");
          }}
          color="secondary"
        >
          View CRF
        </Button>
      ),
    },
  ];

  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };
  const handleFilter = (value) => {
    setFilterValue(value);
  };

  const toggleDrawer = () => {
    setFilterAction(null);
  };
  return (
    <>
      {!action && (
        <div>
          <HeaderMenu />
          <div className={classes.bodyContainer}>
            <br />
            <Grid container>
              <Grid item xs={10}>
                <Typography
                  variant="h1"
                  className={classes.title}
                  style={{ marginLeft: "40px", color: "#077f83" }}
                >
                  Coaching requests
                </Typography>
              </Grid>
              <Grid item xs={2}>
                {!isAdmin && (
                  <Button
                    onClick={(event) => setCompleteAction(true)}
                    variant="contained"
                    style={{ textTransform: "initial", marginLeft: "57px" }}
                    color="secondary"
                  >
                    Complete a CRF
                  </Button>
                )}
              </Grid>
            </Grid>
          </div>
          <br />
          <div className={classes.tableWrapper}>
            <div className={classes.wrapperFilter}>
              {/* <ProgressBox currentSelection={data} /> */}
              <Paper
                elevation={3}
                className={
                  filterValue === null
                    ? `${classes.statsBoard} ${classes.activeTab}`
                    : `${classes.statsBoard}`
                }
              >
                <IconButton
                  style={{ backgroundColor: "transparent" }}
                  onClick={() => {
                    handleFilter(null);
                  }}
                >
                  <div>
                    <Typography
                      variant="h2"
                      style={{ color: "#320032" }}
                      gutterBottom
                    >
                      All CRF
                    </Typography>
                    <div>
                      <Typography
                        style={{ color: "#320032", fontWeight: "bold" }}
                        variant="h2"
                        gutterBottom
                        component="span"
                      >
                        {data.all || 0}
                      </Typography>
                    </div>
                  </div>
                  <div className={classes.IconBorderAll}>
                    <CRFIcon1 style={{ width: "68%" }} />
                  </div>
                </IconButton>
              </Paper>
              <Paper
                elevation={3}
                className={
                  filterValue === "Pending review by acuity"
                    ? `${classes.statsBoard} ${classes.activeTab}`
                    : `${classes.statsBoard}`
                }
              >
                <IconButton
                  style={{ backgroundColor: "transparent" }}
                  onClick={() => {
                    handleFilter("Pending review by acuity");
                  }}
                >
                  <div>
                    <Typography
                      variant="h2"
                      style={{ color: "#320032" }}
                      gutterBottom
                    >
                      Pending review
                    </Typography>
                    <div>
                      <Typography
                        style={{ color: "#320032", fontWeight: "bold" }}
                        variant="h2"
                        gutterBottom
                        component="span"
                      >
                        {data.pending_review_by_acuity || 0}
                      </Typography>
                    </div>
                  </div>
                  <div className={classes.IconBorder}>
                    <CRFIcon1 style={{ width: "68%" }} />
                  </div>
                </IconButton>
              </Paper>
              <Paper
                elevation={3}
                className={
                  filterValue === "Approved"
                    ? `${classes.statsBoard} ${classes.activeTab}`
                    : `${classes.statsBoard}`
                }
              >
                <IconButton
                  style={{ backgroundColor: "transparent" }}
                  onClick={() => {
                    handleFilter("Approved");
                  }}
                >
                  <div>
                    <Typography
                      variant="h2"
                      style={{ color: "#320032" }}
                      gutterBottom
                    >
                      Approved
                    </Typography>
                    <div>
                      <Typography
                        style={{ color: "#320032", fontWeight: "bold" }}
                        variant="h2"
                        gutterBottom
                        component="span"
                      >
                        {data.approved || 0}
                      </Typography>
                    </div>
                  </div>
                  <div className={classes.IconBorder1}>
                    <CRFIcon2 style={{ width: "68%" }} />
                  </div>
                </IconButton>
              </Paper>
              <Paper
                elevation={3}
                className={
                  filterValue === "Acknowledged"
                    ? `${classes.statsBoard} ${classes.activeTab}`
                    : `${classes.statsBoard}`
                }
              >
                <IconButton
                  style={{ backgroundColor: "transparent" }}
                  onClick={() => {
                    handleFilter("Acknowledged");
                  }}
                >
                  <div>
                    <Typography
                      variant="h2"
                      style={{ color: "#320032" }}
                      gutterBottom
                    >
                      Acknowledged{" "}
                    </Typography>
                    <div>
                      <Typography
                        style={{ color: "#320032", fontWeight: "bold" }}
                        variant="h2"
                        gutterBottom
                        component="span"
                      >
                        {data.acknowledged || 0}
                      </Typography>
                    </div>
                  </div>
                  <div className={classes.IconBorderReq}>
                    <CRFIcon3 style={{ width: "58%" }} />
                  </div>
                </IconButton>
              </Paper>
              <Paper
                elevation={3}
                className={
                  filterValue === "Decline"
                    ? `${classes.statsBoard} ${classes.activeTab}`
                    : `${classes.statsBoard}`
                }
              >
                <IconButton
                  style={{ backgroundColor: "transparent" }}
                  onClick={() => {
                    handleFilter("Declined");
                  }}
                >
                  <div>
                    <Typography
                      variant="h2"
                      style={{ color: "#320032" }}
                      gutterBottom
                    >
                      Declined
                    </Typography>
                    <div>
                      <Typography
                        color="secondary"
                        style={{ color: "#320032", fontWeight: "bold" }}
                        variant="h2"
                        gutterBottom
                        component="span"
                      >
                        {data.declined || 0}
                      </Typography>
                    </div>
                  </div>
                  <div className={classes.IconBorder1}>
                    <CRFIcon4 style={{ width: "68%" }} />
                  </div>
                </IconButton>
              </Paper>
            </div>
          </div>
          <div className={classes.bodyContainer1}>
            <div className={classes.wrapper}>
              <Popper
                style={{ zIndex: "1500" }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
              ></Popper>
              <InputBase
                fullWidth
                style={{
                  height: 50,
                  paddingLeft: 10,
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                }}
                placeholder="Search anything"
                value={searchTextSelect}
                onChange={(e) => handleSearchText(e.target.value)}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
              />
            </div>
            {loading && <Loader />}
            <MaterialTable
              style={{
                width: "95%",
                marginLeft: "41px",
              }}
              title=""
              options={{
                actionsColumnIndex: -1,
                searchFieldAlignment: "left",
                emptyRowsWhenPaging: false,
                search: false,
                actionsCellStyle: {
                  borderBottom: "none",
                },
                pageSize: pageSize,
                total: totalCount,
                searchText: searchText,
                tableLayout: "fixed",
                rowStyle: {
                  height: "auto",
                },
                pageSizeOptions: [20, 50, 75, 100],
                headerStyle: {
                  position: "sticky",
                  top: "0",
                },
                maxBodyHeight: "600px",
              }}
              columns={columns}
              data={apiData}
              totalCount={totalCount}
              page={page}
              onRowClick={(e, rowData) => {
                setCurrentSelection(rowData);
              }}
              onChangePage={(page) => {
                setPage(page);
              }}
              onChangeRowsPerPage={(pageSize) => {
                setPageSize(pageSize);
              }}
              onSearchChange={(search) => {
                setSearchText(search);
              }}
              actions={[
                {
                  icon: () => <FilterList color="secondary" />,
                  tooltip: <TooltipWrapper text="Filter" />,
                  isFreeAction: true,
                  onClick: (event, rowData) => {
                    setCurrentSelection(rowData);
                    setFilterAction("filter");
                    // toggleDrawer(true)
                  },
                },
              ]}
            />

            <div>
              {filterAction === "filter" && (
                <RightDrawer onClose={toggleDrawer}>
                  <div className={"align-left-space-between"}>
                    <div>&nbsp;</div>
                    <IconButton
                      onClick={toggleDrawer}
                      style={{ padding: "8px" }}
                    >
                      <CloseIcon fontSize={"small"} />
                    </IconButton>
                  </div>
                  <Typography
                    style={{
                      marginTop: "-30px",
                      color: "#077f83",
                      fontWeight: 700,
                      marginLeft: "-10px",
                    }}
                    variant="subtitle2"
                    gutterBottom
                  >
                    {role === "employee"
                      ? "Filter based on  coachee name "
                      : "Filter based on organization & coachee name"}
                  </Typography>
                  <br />
                  {role === "employee" ? (
                    <Grid container>
                      <Grid item xs={8}>
                        <Typography
                          variant="subtitle2"
                          color="secondary"
                          className={classes.title}
                          style={{ fontSize: "14px", marginBottom: "10px" }}
                        >
                          Coachee name
                        </Typography>
                      </Grid>
                      <br />
                      <Grid item xs={12}>
                        {/* <CustomInput id="label" value={feildName} parentcall={setInputState} required variant="outlined" style={{ backgroundColor: "#fff" }} defaultValue={data.label} placeholder="Coachee Name" /> */}

                        <div className={classes1.root}>
                          <Autocomplete
                            value={empValue}
                            onChange={(event, newValue) => {
                              setEmpValue(newValue);
                            }}
                            inputValue={empInputValue}
                            onInputChange={(event, newInputValue) => {
                              setEmpInputValue(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={empData}
                            getOptionLabel={(option) => option.full_name}
                            style={{ width: 300 }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Search employee name"
                                variant="outlined"
                                style={{ height: 40 }}
                              />
                            )}
                          />
                        </div>
                      </Grid>
                      <div className={classes.actionButtons}>
                        <Button
                          disableElevation
                          disabled={loading}
                          type="button"
                          variant={"contained"}
                          onClick={handleClear}
                          style={{
                            position: "relative",
                            left: "120px",
                            textTransform: "none",
                          }}
                        >
                          Clear
                        </Button>
                        <Button
                          disableElevation
                          disabled={loading}
                          onClick={getData}
                          variant={"contained"}
                          color="secondary"
                          style={{
                            position: "relative",
                            left: "130px",
                            textTransform: "none",
                          }}
                        >
                          Search
                        </Button>
                      </div>
                    </Grid>
                  ) : (
                    <div>
                      <Typography
                        variant="subtitle2"
                        color="secondary"
                        className={classes.title}
                      ></Typography>
                      <Grid
                        container
                        spacing={1}
                        alignItems={"center"}
                        justify={"flex-start"}
                      >
                        <React.Fragment>
                          <Grid item xs={12}>
                            <Typography
                              variant="subtitle2"
                              color="secondary"
                              className={classes.title}
                              style={{ fontSize: "14px", marginLeft: "-16px" }}
                            >
                              Organization name
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <div className={classes1.root}>
                              <Autocomplete
                                value={value}
                                onChange={(event, newValue) => {
                                  if (newValue === null) {
                                    newValue = "";
                                  }
                                  setValue(newValue);
                                }}
                                disabled={role === "employee" ? true : false}
                                inputValue={inputValue}
                                onInputChange={(event, newInputValue) => {
                                  setInputValue(newInputValue);
                                }}
                                id="controllable-states-demo"
                                options={selectData}
                                getOptionLabel={(option) =>
                                  option.organisation_name
                                }
                                style={{ width: 340, marginLeft: "-15px" }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search organization name"
                                    variant="outlined"
                                  />
                                )}
                              />
                            </div>
                          </Grid>
                          <br />
                          <Grid item xs={12}>
                            <Typography
                              variant="subtitle2"
                              color="secondary"
                              className={classes.title}
                              style={{ fontSize: "14px", marginLeft: "-16px" }}
                            >
                              Coachee name
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <div className={classes1.root}>
                              <Autocomplete
                                value={empValue}
                                onChange={(event, newValue) => {
                                  setEmpValue(newValue);
                                }}
                                inputValue={empInputValue}
                                onInputChange={(event, newInputValue) => {
                                  setEmpInputValue(newInputValue);
                                }}
                                id="controllable-states-demo"
                                options={empData}
                                getOptionLabel={(option) => option.full_name}
                                style={{ width: 340, marginLeft: "-15px" }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search employee name"
                                    variant="outlined"
                                  />
                                )}
                              />
                            </div>
                          </Grid>
                        </React.Fragment>
                      </Grid>

                      <div className={classes.actionButtons}>
                        <Button
                          disableElevation
                          disabled={loading}
                          type="button"
                          variant={"contained"}
                          onClick={handleClear}
                          // onClick={setInputValue("")}
                          style={{
                            position: "relative",
                            right: "31px",
                            textTransform: "none",
                          }}
                        >
                          Clear
                        </Button>
                        <Button
                          disableElevation
                          disabled={loading}
                          onClick={getData}
                          variant={"contained"}
                          color="secondary"
                          style={{
                            position: "relative",
                            right: "19px",
                            textTransform: "none",
                          }}
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                  )}
                </RightDrawer>
              )}
            </div>
          </div>
        </div>
      )}
      {/* {action && (
        <ManageCompleteCRF
          action={action}
          getCRFList={getData}
          CoachinRequest={currentSelection}
          handleClose={handleClose}
        />
      )} */}
      {action && (
        <CompleteCrf
          action={action}
          getCRFList={getData}
          CoachinRequest={currentSelection}
          handleClose={handleClose}
        />
      )}
      {completeAction && (
        <ManageTemplate
          action={completeAction}
          crfId={currentSelection.coaching_request_form_id}
          data={currentSelection}
          onClose={setCompleteAction}
          open={completeAction}
          getData={getData}
        />
      )}
    </>
  );
}
